/* eslint-disable */
import store from "../../store/index";
import axios from "axios";

export default {
  name: "EditStudyPopUp",
  props: {
    studyid: String,
    selectedversion: String
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      selectedstudy: "",
      selectedVersion: "",
      classficationList: [],
      selectedStudyType: "",
      enrolment: "",
      allocation: "",
      intervention: "",
      masking: "",
      purpose: "",
      title: "",
      currentVersionDetails: {
        version: "",
        createdAt: "",
        createdUserId: "",
        createdUserEmail: "",
        lastModifiedAt: "",
        lastModifiedUserId: "",
        lastModifiedUserEmail: "",
         isArmSpecific:true,
        reasonForChange: "",
        regulatoryRef: "",
        changeType: "",
        reqReConsent: false,
        approval: []
      },
      values: {
        accountId: "string",
        folderId: "string",
        studyRef: "",
        studyName: "",
        sponsor: "",
        status: "New",
        studyId: "",
        studyNotes: "",
        preVisit: "",
        postVisit: "",
        numberOfSite: "",
        numberOfPatient: "",
        duration: 0,
        active: true,
        isDeleted: false,
        studyProperties: [],
        versions: [],
        currentVersion: ""      
      },
      numerrors: {
        preVisit: true,
        postVisit: true,
        numberOfSite: true,
        numberOfPatient: true,
        duration: true
      },
      validations: [false, false],
      errors: []
    };
  },
  mounted() {
    this.selectedstudy = this.studyid;
    this.selectedVersion = this.selectedversion;
    this.retrieveinfo();
    this.getClassfications();  
  },
  methods: {
    async getClassfications() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(`${this.baseurl}/management/study/getstudyclassifications`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json"
          }
        });
        const data = Array.isArray(res.data) ? res.data : res.data.classifications || [];

        // Sort each inner classifications array
        data.forEach(item => {
          if (Array.isArray(item.classifications)) {
            item.classifications.sort((a, b) =>
              a.toString().localeCompare(b.toString(), undefined, { sensitivity: 'base' })
            );
          }
        });

        this.classficationList = data;

      } catch (err) {
        console.error("Error loading classifications", err);
      }
    },

    async numberonlyvalidation(fieldname) {
      let isNumber = true;
      this.values[fieldname] = this.values[fieldname] ? this.values[fieldname].replace(/\s/g, '') : "";
      let fieldval = this.values[fieldname];
      if (fieldval % 1 !== 0 || isNaN(fieldval)) {
        isNumber = false;
      }
      if (!isNumber || parseInt(this.values[fieldname]) < 0) {
        this.values[fieldname] = 0;
        this.numerrors[fieldname] = false;
      } else {
        this.numerrors[fieldname] = true;
      }
    },

    async validate() {
      this.values.studyName = this.values.studyName ? this.values.studyName.replace(/ +/g, ' ').trim() : "";
      this.values.sponsor = this.values.sponsor ? this.values.sponsor.replace(/ +/g, ' ').trim() : "";
      this.values.studyNotes = this.values.studyNotes ? this.values.studyNotes.replace(/ +/g, ' ').trim() : "";
      this.values.studyRef = this.values.studyRef ? this.values.studyRef.replace(/ +/g, ' ').trim() : "";

      this.validations[0] = this.values.studyName !== "";
      this.validations[1] = this.values.studyRef !== "";
    },

    generateDescription() {
      this.values.studyProperties = [
        `Study Type: ${this.selectedStudyType}`,
        `Estimated Enrollment: ${this.enrolment}`,
        `Allocation: ${this.allocation}`,
        `Intervention Model: ${this.intervention}`,
        `Masking: ${this.masking}`,
        `Primary Purpose: ${this.purpose}`,
        `Official Title: ${this.title}`
      ];
    },

    async edit() {
      this.generateDescription();
      await this.validate();
      if (this.validations.includes(false)) {
        this.errors = this.validations;
        return;
      }

      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(
          `${this.baseurl}/management/study/update?api-version=1.0`,
          this.values,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );
        alert(this.$t("navigations.study updated successfully"));
        this.$emit("studyChanged");
        this.$emit("closeModal");
      } catch (err) {
        alert(err.response?.data?.detail || "Update failed");
      }
    },

    async retrieveinfo() {
      console.log("Retrieving info for study ID:", this.selectedstudy, "and version:", this.selectedVersion);
      const idtoken = store.getters.getIdToken;
      console.log("Current Version set to:", this.values);
      if (!this.selectedstudy || this.selectedstudy === "0") return;

      try {
        const response = await axios.get(
          `${this.baseurl}/management/study/getbyid?id=${this.selectedstudy}&version=${this.selectedVersion}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json"
            }
          }
        );

        const data = response.data;
        this.values = data;
        this.values.currentVersion = this.selectedVersion;


        if (this.values.versions && this.values.versions.length > 0) {
          // Get the latest version (or use a specific logic)
          this.currentVersionDetails = this.values.versions[this.values.versions.length - 1];
          console.log("Current Version Details:", this.currentVersionDetails);
          console.log("Current Version Details:", this.currentVersionDetails.regulatoryRef);

        }

        if (data.studyName) {
          this.title = data.studyName;
        }

        // Populate dropdowns
        const props = {};
        if (Array.isArray(data.studyProperties)) {
          data.studyProperties.forEach((item) => {
            const idx = item.indexOf(":");
            if (idx > -1) {
              const key = item.substring(0, idx).trim();
              const val = item.substring(idx + 1).trim();
              if (key) props[key] = val;
            }
          });
        }

        this.selectedStudyType = props["Study Type"] || "";
        this.enrolment = props["Estimated Enrollment"] || "";
        this.allocation = props["Allocation"] || "";
        this.intervention = props["Intervention Model"] || "";
        this.masking = props["Masking"] || "";
        this.purpose = props["Primary Purpose"] || "";
        this.title = props["Official Title"] || "";
      } catch (err) {
        console.error("Failed to retrieve study info:", err);
      }
    },

    async closeModal() {
      this.$emit("closeModal");
    },
    async addStudy() {
      if (this.selectedstudy == 0) {
        this.save();
      }
      else {
        this.edit();
      }
    },

    async clear() {
      this.values = {
        accountId: this.values.accountId,
        folderId: "string",
        studyName: "",
        sponsor: "",
        status: "",
        studyId: this.values.studyId,
        studyNotes: "",
        duration: 0,
        preVisit: 0,
        postVisit: 0,
        numberOfSite: 0,
        numberOfPatient: 0,
        active: false,
        isArmSpecific: false,
        isDeleted: false,
        studyProperties: []
      };
      this.selectedStudyType = "";
      this.enrolment = "";
      this.allocation = "";
      this.intervention = "";
      this.masking = "";
      this.purpose = "";
      this.title = "";
      this.validations = [false, false];
      this.errors = [];
    }
  }
};
